import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a7efeb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "auth-form"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Изменение пароля", -1))
const _hoisted_3 = { class: "auth-form-components" }
const _hoisted_4 = { class: "flex flex-col input-labeled" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "oldPassword" }, "Текущий пароль", -1))
const _hoisted_6 = { class: "form-block password" }
const _hoisted_7 = { class: "flex flex-col input-labeled" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newPassword" }, "Новый пароль", -1))
const _hoisted_9 = { class: "flex flex-col input-labeled" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "newPasswordDouble" }, "Подтверждение нового пароля", -1))
const _hoisted_11 = {
  key: 0,
  class: "bad-msg"
}
const _hoisted_12 = {
  key: 0,
  class: "fl-senter m-t-5"
}
const _hoisted_13 = {
  key: 1,
  class: "auth-form"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Новый пароль", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-t-8" }, "Новый пароль успешно сохранен.", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

import { ref, watch } from "vue";

import { useRouter } from "vue-router";
import { useUsersStore } from "@/store/users/users";
import { rootGetters } from "@/main";

import Button from "primevue/button";
import ProgressSpinner from "primevue/progressspinner";
import Password from "primevue/password";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordChangeForm',
  setup(__props) {

const usersStore = useUsersStore();
const router = useRouter();
const isProgress = ref(false);
const endForm = ref(false);
const password = ref({
  oldPassword: "",
  newPassword: "",
  doubleNewPassword: "",
});
const invalid = ref(false);
const debounceTimeout = ref(null as number | null);

const sendItemRequest = () => {
  if (password.value.doubleNewPassword != password.value.newPassword) {
    invalid.value = true;
  } else invalid.value = false;
};

watch(
  () => password.value.doubleNewPassword,
  () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(sendItemRequest, 1000);
  }
);

watch(
  () => password.value.newPassword,
  () => {
    if (password.value.doubleNewPassword != "") {
      if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
      debounceTimeout.value = setTimeout(sendItemRequest, 1000);
    }
  }
);

function changePassword() {
  if (invalid.value) {
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что пароли совпадают.`
    );
    return;
  }

  isProgress.value = true;

  usersStore
    .changePassword({
      new_password: password.value.newPassword,
      old_password: password.value.oldPassword,
    })
    .then(() => {
      endForm.value = true;
      setTimeout(() => {
        router.push({ name: "personalAccount" });
      }, 3000);
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    })
    .finally(() => {
      isProgress.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  return (!endForm.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(Password), {
              id: "oldPassword",
              modelValue: password.value.oldPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password.value.oldPassword) = $event)),
              placeholder: "Введите пароль",
              feedback: false,
              toggleMask: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_unref(Password), {
                id: "newPassword",
                modelValue: password.value.newPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password.value.newPassword) = $event)),
                placeholder: "Введите новый пароль",
                feedback: false,
                toggleMask: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_unref(Password), {
                id: "newPasswordDouble",
                modelValue: password.value.doubleNewPassword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password.value.doubleNewPassword) = $event)),
                placeholder: "Введите новый пароль",
                feedback: false,
                toggleMask: "",
                invalid: invalid.value
              }, null, 8, ["modelValue", "invalid"])
            ]),
            (invalid.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Пароли не совпадают"))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(Button), {
            label: "Изменить пароль",
            class: "form-button",
            onClick: changePassword,
            disabled: isProgress.value
          }, null, 8, ["disabled"])
        ]),
        (isProgress.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_unref(ProgressSpinner), {
                "aria-label": "Loading",
                style: {"width":"30px","height":"30px"},
                strokeWidth: "2",
                fill: "var(--surface-ground)"
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
}
}

})